import { Section } from "@/overlay/components/LayerStackWindow/EnergyPlotSettings/Section";
import { SerieOptions } from "@/overlay/components/LayerStackWindow/EnergyPlotSettings/SerieOptions";
import { FormField } from "@/overlay/components/form-field";
import type { PlotSerieStyle } from "@/types/data";
import { t } from "@lingui/core/macro";

interface RunSectionProps {
  title: string;
  runStyle?: PlotSerieStyle;
  deltaStyle?: PlotSerieStyle;
  onRunChange: (serieOption: PlotSerieStyle) => void;
  onDeltaChange: (serieOption: PlotSerieStyle) => void;
}

/** Applies visibility consistently to a run or delta style and its legend entry. */
function withVisibility(serieStyle: PlotSerieStyle | undefined, visible: boolean): PlotSerieStyle {
  return {
    ...(serieStyle ?? {}),
    visible,
    showInLegend: visible,
  } as PlotSerieStyle;
}

/** Renders visibility and style controls for one selected previous energy run. */
export const RunSection = ({ title, runStyle, deltaStyle, onRunChange, onDeltaChange }: RunSectionProps) => {
  const isDeltaVisible = deltaStyle?.visible ?? true;
  const isRunVisible = runStyle?.visible ?? true;

  return (
    <Section title={title} subSection>
      <FormField label={t`Show delta`}>
        <input
          type="checkbox"
          id={`delta_${title}`}
          checked={isDeltaVisible}
          onChange={(event) => {
            onDeltaChange(withVisibility(deltaStyle, event.target.checked));
          }}
        />
      </FormField>
      {isDeltaVisible && <SerieOptions serieOptions={deltaStyle} onChange={onDeltaChange} />}
      <hr />
      <FormField label={t`Show run`}>
        <input
          type="checkbox"
          id={`run_${title}`}
          checked={isRunVisible}
          onChange={(event) => {
            onRunChange(withVisibility(runStyle, event.target.checked));
          }}
        />
      </FormField>
      {isRunVisible && <SerieOptions serieOptions={runStyle} onChange={onRunChange} />}
    </Section>
  );
};
